import { useEffect, useState } from 'react';
import { Cookies } from 'react-cookie';

import { usePdpConfig } from '../context/ConfigContext';
import { useFeatureList } from '../services/useFeatureList';

interface useDisplayABTProps {
  keys: string[];
}
export const useDisplayABT = ({ keys }: useDisplayABTProps) => {
  const { ZIGZAGUUID } = usePdpConfig();

  const [is_display, setIsDisplay] = useState(false);

  const cookies = new Cookies();
  const user_uuid = cookies.get('ZIGZAGUUID');

  const { feature_list, isLoading } = useFeatureList({ uuid: user_uuid ?? ZIGZAGUUID });
  useEffect(() => {
    const isDisplay = keys.every((key) => feature_list.includes(key));
    setIsDisplay(isDisplay);
  }, [feature_list, keys]);

  return { is_display, feature_list, isLoading };
};
